import React from "react";
import styled from "styled-components";

import {
  AdminSection,
  AdminSectionBadge,
  AdminSectionHeader,
} from "../section_engine";


function displayValue(value) {
  if (
    typeof value === "string"
    && value.trim()
  ) {
    return value.trim();
  }

  return "Non renseigné";
}


function displayBoolean(value) {
  return value
    ? "Associé"
    : "Non associé";
}


export default function EmployeeIdentitySection({
  employee,
  user,
  actions = null,
}) {
  return (
    <AdminSection
      aria-labelledby={
        "employee-identity-section-title"
      }
    >
      <AdminSectionHeader>
        <AdminSectionBadge>
          Identity
        </AdminSectionBadge>

        <h2
          id="employee-identity-section-title"
        >
          Identité
        </h2>

        <p>
          Données Employee et relation User
          disponibles en Phase 2.
        </p>
      </AdminSectionHeader>

      {actions ? (
        <IdentityActions
          aria-label="Actions identité Employee"
        >
          {actions}
        </IdentityActions>
      ) : null}

      <IdentityGrid>
        <IdentityItem>
          <dt>Matricule</dt>
          <dd>
            {displayValue(
              employee?.employee_number,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Prénom</dt>
          <dd>
            {displayValue(
              employee?.first_name,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Nom</dt>
          <dd>
            {displayValue(
              employee?.last_name,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Statut</dt>
          <dd>
            {displayValue(
              employee?.status,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Société</dt>
          <dd>
            {displayValue(
              employee?.company?.name,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Compte utilisateur</dt>
          <dd>
            {displayBoolean(
              user?.linked,
            )}
          </dd>
        </IdentityItem>

        <IdentityItem>
          <dt>Email utilisateur</dt>
          <dd>
            {displayValue(
              user?.email,
            )}
          </dd>
        </IdentityItem>
      </IdentityGrid>
    </AdminSection>
  );
}


const IdentityGrid = styled.dl`
  display: grid;

  grid-template-columns:
    repeat(
      auto-fit,
      minmax(190px, 1fr)
    );

  gap: 0.8rem;

  margin: 0;
`;


const IdentityItem = styled.div`
  min-width: 0;

  padding: 0.75rem;

  border:
    1px solid
    rgba(255, 255, 255, 0.08);

  border-radius: 14px;

  background:
    rgba(11, 19, 40, 0.24);

  dt {
    margin-bottom: 0.35rem;

    color:
      rgba(247, 247, 247, 0.62);

    font-size: 0.76rem;
    font-weight: 700;

    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  dd {
    margin: 0;

    color: #fff9ea;

    font-size: 0.94rem;
    font-weight: 700;

    overflow-wrap: anywhere;
  }
`;


const IdentityActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;

  margin-bottom: 1rem;
`;
